import { NotificationPreferences } from './EntityPreferences';
import { Model } from './Model';

export class NotificationPreferencesUpdate extends Model {
  public apiPath = undefined;
  public className = 'updateNotificationPreferences';
  public notificationPreferences: NotificationPreferences;
}
